module.exports = __webpack_public_path__ + "static/media/197.370a65ee.png";